class BrowserEventTracker {
    constructor(trackingMethod = () => {}) {
        this.trackingMethod = trackingMethod;
    }

    track(...args) {
        this.trackingMethod(...args);
    }
}

module.exports = BrowserEventTracker;